import { ReturnReason, ReturnReasonItem } from "../../redux/slices/orderSettings.slice";

export interface TipOptionsState {
    ten: boolean;
    fifteen: boolean;
    twenty: boolean;
    custom: boolean;
    noTip: boolean;
}

export interface TipSettingsFormValues {
    enableTipsPercentage: boolean;
    tipOptions: TipOptionsState;
}

export const TIP_PERCENTAGE_OPTIONS: { id: number; label: string; key: keyof TipOptionsState }[] = [
    { id: 1, label: "10", key: "ten" },
    { id: 2, label: "15", key: "fifteen" },
    { id: 3, label: "20", key: "twenty" },
    { id: 4, label: "Custom", key: "custom" },
    { id: 5, label: "No Tip", key: "noTip" },
];

export interface ReturnReasonUIItem extends ReturnReasonItem {
    id?: number;
    isCustom?: boolean;
    isNew?: boolean;
    isFromApi?: boolean; // loaded from GET return-reason, so id is a real DB id
}

export type ReturnWindowOptionValue = "14_DAYS" | "30_DAYS" | "90_DAYS" | "UNLIMITED" | "CUSTOM_DAYS";

export interface ReturnWindowOption {
    id: number;
    label: string;
    value: ReturnWindowOptionValue;
    days: number | null;
}

export interface OrderSettingsFormValues {
    // Return Window
    returnWindow: string;
    // Order ID
    orderIdPrefixText: string;
    orderIdSuffixText: string;
    // UPI Payment
    upiId: string;
    // Round off the sell screen grand total to the nearest ₹1
    isRoundOff: boolean;
}

export const RETURN_WINDOW_OPTIONS: ReturnWindowOption[] = [
    { id: 1, label: "14 days", value: "14_DAYS", days: 14 },
    { id: 2, label: "30 days", value: "30_DAYS", days: 30 },
    { id: 3, label: "90 days", value: "90_DAYS", days: 90 },
    { id: 4, label: "Unlimited", value: "UNLIMITED", days: null },
    { id: 5, label: "Custom Days", value: "CUSTOM_DAYS", days: null },
];

